<template>
  <div class="container-fluid">
    <div class="row">
      <div class="col-12">
        <div class="page-title-box">
          <h4 class="page-title">Assessment Timeline</h4>
        </div>
      </div>
    </div>
    <!-- end page title -->
    <div class="row">
      <div class="col-lg-12">
        <div class="card">
          <div class="card-body">
            <div v-if="loading" class="text-center py-5">
              <div class="spinner-border text-primary" role="status">
                <span class="visually-hidden">Loading...</span>
              </div>
            </div>
            <div class="row mb-3">
              <!-- Module Filter -->
              <div class="col-md-3">
                <label>Module</label>
                <v-select :options="modules" label="name" :reduce="m => m.id" v-model="filters.module_id"
                  placeholder="All Modules" />
              </div>

              <!-- Trainer Filter -->
              <div class="col-md-3">
                <label>Trainer</label>
                <v-select
                  :options="trainers"         
                  label="name"                
                  :reduce="t => t.employee_id" 
                  v-model="filters.trainer_id"
                  placeholder="All Trainers"
                />
              </div>

              <!-- Created Date -->
              <div class="col-md-3">
                <label>Training Date</label>
                <input type="date" class="form-control" v-model="filters.created_at" />
              </div>

              <!-- Buttons -->
              <div class="col-md-3 d-flex align-items-end">
                <div @click="resetFilters" class="icon-css mt-3">
                  <i style="color: #4a81d4" class="fe-rotate-cw"></i>
                </div>
              </div>
            </div>
            <div class="table-responsive" v-if="!loading">
              <table class="table table-striped dt-responsive w-100 mb-3" id="datatable">
                <thead>
                  <tr>
                    <th>No.</th>
                    <th>Employee ID</th>
                    <th>Employee Name</th>
                    <th>Module</th>
                    <th>Business Unit</th>
                    <th>Training Date</th>
                    <th>Trainer Name</th>
                    <th>Expire Date</th>
                    <th>User Status</th>
                    <th>Active Status</th>
                    <th>Status</th>
                    <th>Action</th>
                    <th>Resend</th>
                  </tr>
                </thead>
                <tbody></tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
//Datatable Program Timeline
import "datatables.net/js/jquery.dataTables.min.js";
import "datatables.net-bs5/css/dataTables.bootstrap5.min.css";
import "datatables.net-bs5/js/dataTables.bootstrap5.min.js";
import "datatables.net-responsive-bs5/css/responsive.bootstrap5.min.css";
import "datatables.net-responsive-bs5/js/responsive.bootstrap5.min.js";
import $ from "jquery";
import axios from "axios";
import { useToast } from "vue-toastification";
import badgeSuccess from "../../../components/shared/badgeSuccess.vue";
import badgeDanger from "../../../components/shared/badgeDanger.vue";
import vSelect from "vue-select";
import "vue-select/dist/vue-select.css";
//Mixins
import userHasPermissions from "../../../mixins/userHasPermissions";

export default {
  name: 'AssessmentTimeline',
  components: {
    badgeSuccess,
    badgeDanger,
    vSelect,
  },
  mixins: [userHasPermissions],
  setup() {
    const toast = useToast();
    return { toast };
  },
  data() {
    return {
      employees: [],
      assessment_timeline: [],
      status: "",
      arr_status: [{ name: "Active" }, { name: "Inactive" }],
      loading: false,
      baseUrl: process.env.VUE_APP_BASE_URL,
      dataTableInstance: null,
      filters: {
        module_id: null,
        trainer_id: null,
        created_at: null,
      },
      modules: [],
      trainers: [],
    };
  },
  watch: {
    "filters.module_id"(newVal) {
      this.getAssessmentTimeline();
    },
    "filters.trainer_id"(newVal) {
      this.getAssessmentTimeline();
    },
    "filters.created_at"(newVal) {
      this.getAssessmentTimeline();
    }
  },
  methods: {
    async getModules() {
      try {
        const res = await axios.get(`${this.baseUrl}admin/v3/module-list`);
        this.modules = res.data.data || [];
      } catch (e) {
        console.error("Failed to load modules", e);
      }
    },
    async getTrainers() {
      try {
        const res = await axios.get(`${this.baseUrl}admin/v3/trainer-list`);
        this.trainers = res.data.data || [];
      } catch (e) { 
        console.error("Failed to load trainers", e);
      }
    },
    getEmployeeName(data) {
      // Check for employee name in different possible locations
      if (data.enrolled_user?.name) {
        return data.enrolled_user.name;
      } else if (data.name) {
        return data.name;
      } else if (data.enrolled_user_id) {
        // Try to find in employees array
        const employee = this.employees.find(emp => emp.emp_id === data.enrolled_user_id);
        return employee ? employee.name : data.enrolled_user_id;
      }
      return '-';
    },

    getStatusText(status) {
      // Map status codes to text
      switch (parseInt(status)) {
        case 0:
          return 'Waiting';
        case 1:
          return 'On Progress';
        case 2:
          return 'Complete';
        case 3:
          return 'Cancel'
        default:
          return 'Draft';
      }
    },

    getStatusClass(status) {
      // Map status codes to CSS classes
      switch (parseInt(status)) {
        case 0: // Waiting
          return 'badge-warning';
        case 1: // Pending
          return 'badge-info';
        case 2: // Complete
          return 'badge-success';
        default:
          return 'badge-secondary';
      }
    },

    async getAssessmentTimeline() {
      this.loading = true;
      this.$Progress.start();
      // console.log(this.buildQueryParams());

        try {
          const response = await axios.get(
            `${this.baseUrl}admin/v3/self-assessment`,
            {
              params: this.buildQueryParams()
            }
          );

          this.assessment_timeline = response.data.data || [];
          // console.log("Fetched assessment timeline:", this.assessment_timeline);
          this.loading = false;
          this.$Progress.finish();

          this.$nextTick(() => {
            this.initializeDataTable();
          });

        } catch (error) {
          console.error(error);
          this.toast.error("Something Went Wrong!");
          this.loading = false;
          this.$Progress.fail();
        }
    },

    initializeDataTable() {
      if (this.dataTableInstance) {
        this.dataTableInstance.destroy();
        $("#datatable tbody").off(); // remove old listeners
      }

      const vm = this;

      this.dataTableInstance = $("#datatable").DataTable({
        data: this.assessment_timeline,
        responsive: true,
        pageLength: 10,
        columns: [
          { data: null }, // No.
          { data: null }, // Employee ID
          { data: null }, // Employee Name
          { data: null }, // Module
          { data: null }, // Business Unit
          { data: null }, // Training Date
          { data: null }, // Trainer Name
          { data: null }, // Expire Date
          { data: null }, // User Status
          { data: null }, // Active Status
          { data: null }, // Status
          { data: null }, // Action
          { data: null }  // Resend
        ],
        columnDefs: [
          {
            targets: 0,
            render: (data, type, row, meta) => meta.row + 1
          },
          {
            targets: 1,
            render: (data, type, row) => {
              return row.enrolled_user?.employee_id || row.enrolled_user_id || "-";
            }
          },
          {
            targets: 2,
            render: (data, type, row) => vm.getEmployeeName(row)
          },
          {
            targets: 3,
            render: (data, type, row) => row.monthly_plan?.module?.name || "-"
          },
          {
            targets: 4,
            render: (data, type, row) => {
              const bu = row.business_unit_name;

              if (!bu) return "-";

              if (typeof bu === "object") {
                return bu.name || "-";
              }

              return bu; // already string
            }
          },
          {
            targets: 5,
            render: (data, type, row) => row.monthly_plan?.from_date || "-"
          },
          {
            targets: 6,
            render: (data, type, row) => {
              const trainer = row.trainer_names;

              if (!trainer) return "-";

              if (typeof trainer === "object") {
                return trainer.name || "-";
              }

              return trainer;
            }
          },
          {
            targets: 7, // Expire Date
            render: (data, type, row) => {
              return row?.expire_date ?? "-";
            }
          },
          {
            targets: 8,
            render: (data, type, row) => vm.isResigned(row)
          },
          {
            targets: 9, // Active Status
            render: (data, type, row) => {
              return vm.getActiveStatus(row);
            }
          },
          {
            targets: 10,
            render: (data, type, row) => vm.getStatusText(row.status)
          },
          {
            targets: 11,
            render: (data, type, row, meta) => {
              if (!vm.hasPermissions(["self-assessment-timeline-edit"])) return "";

              return `
              <button class="btn btn-link text-primary edit-btn"
                data-id="${row.id}">
                <i class="mdi mdi-square-edit-outline"></i>
              </button>
            `;
            }
          },
          {
            targets: 12, // Resend Button
            render: (data, type, row, meta) => {
              if (!vm.canResendRow(row) || !vm.hasPermissions(["self-assessment-resend-form"])) {
                return "";
              }

              return `
              <button class="btn btn-warning btn-sm resend-btn" data-id="${row.id}">
                <span class="btn-text">Resend</span>
                <span class="spinner-border spinner-border-sm d-none btn-spinner"></span>
              </button>
            `;
            }
          }
        ]
      });

      // EDIT BUTTON (Vue Router navigation)
      $("#datatable tbody").on("click", ".edit-btn", function () {
        const id = $(this).data("id");

        vm.$router.push({
          name: "after-month-assessment-timeline-edit",
          params: { id }
        });
      });

      // Attach click listener for resend button
      $("#datatable tbody").on("click", ".resend-btn", async function () {
        const button = $(this); // clicked button
        const spinner = button.find(".btn-spinner");
        const btnText = button.find(".btn-text");
        const rowData = vm.dataTableInstance.row(button.closest("tr")).data();

        // Disable button and show spinner
        spinner.removeClass("d-none");
        btnText.addClass("d-none");
        button.prop("disabled", true);

        try {
          // Call API
          await axios.put(`${vm.baseUrl}admin/v3/self-assessment-resend/${rowData.id}`, {
            action: "resend"
          });

          // Fetch updated row
          const response = await axios.get(`${vm.baseUrl}admin/v3/self-assessment/${rowData.id}`);
          const updated = response.data?.data;
          if (!updated) throw new Error("Failed to fetch updated data");

          // Update Vue reactive array
          const rowIndex = vm.assessment_timeline.findIndex(item => item.id === updated.id);
          vm.assessment_timeline.splice(rowIndex, 1, updated);

          // Update DataTable row
          vm.dataTableInstance
            .row(button.closest("tr"))
            .data(updated)
            .invalidate()
            .draw(false);

          vm.toast.success("Assessment resent successfully.");
        } catch (error) {
          console.error(error);
          vm.toast.error("Failed to resend assessment.");
        } finally {
          // Hide spinner and enable button (optional if button disappears after resend)
          spinner.addClass("d-none");
          btnText.removeClass("d-none");
          button.prop("disabled", false);
        }
      });
    },

    canResendRow(row) {
      if (!row) return false;

      // Status 1 = On Progress, 2 = Complete → cannot resend
      if (parseInt(row.status) === 1) return false;
      if (parseInt(row.status) === 2) return false;
      if (parseInt(row.status) === 3) return false;
      if (parseInt(row.status) === 4) return false;

      if (!row.expire_date) return false;

      // Already resent
      if (parseInt(row.resend) === 1) return false;

      const today = new Date();
      today.setHours(0, 0, 0, 0);

      const expireDate = new Date(row.expire_date);
      expireDate.setHours(0, 0, 0, 0);

      // Allow resend ONLY when expired
      return expireDate < today;
    },

    isResigned(data) {
      return data.resign === 1 ? 'Resign' : 'Active'
    },

    async resendAssessment(row, index) {
      const vm = this;
      const button = $(`#datatable tbody tr`).eq(index).find(".resend-btn");
      const spinner = button.find(".btn-spinner");
      const btnText = button.find(".btn-text");

      try {
        // Show spinner
        spinner.removeClass("d-none");
        btnText.addClass("d-none");
        button.prop("disabled", true);

        // Call API to resend
        await axios.put(`${this.baseUrl}admin/v3/self-assessment-resend/${row.id}`, {
          action: "resend"
        });

        // Fetch updated row
        const response = await axios.get(`${this.baseUrl}admin/v3/self-assessment/${row.id}`);
        const updated = response.data?.data;
        if (!updated) throw new Error("Failed to fetch updated data");

        // Update Vue reactive array
        vm.assessment_timeline.splice(index, 1, updated);

        // Update DataTable row
        vm.dataTableInstance
          .row(index)
          .data(updated)
          .invalidate()
          .draw(false);

        vm.toast.success("Assessment resent successfully.");
      } catch (error) {
        console.error(error);
        vm.toast.error("Failed to resend assessment.");
      } finally {
        // Hide spinner and re-enable button if needed
        spinner.addClass("d-none");
        btnText.removeClass("d-none");
        button.prop("disabled", false);
      }
    },

    getActiveStatus(data) {
      if (!data.expire_date) return data.resend === 1 ? "Resent" : "";

      const [year, month, day] = data.expire_date.split('-').map(Number);
      const expireDate = new Date(year, month - 1, day);

      const today = new Date();
      today.setHours(0, 0, 0, 0);

      // Expired → not resent, status = 0, expireDate < today
      if (data.status === 0 && data.resend !== 1 && expireDate < today) {
        return "Expired";
      }

      // Overdue → already resent but expired
      if (data.resend === 1 && expireDate < today) {
        return "Overdue";
      }

      // Resent → already resent and not yet expired
      if (data.resend === 1 && expireDate >= today) {
        return "Resent";
      }

      return "";
    },

    resetFilters() {
      this.filters = {
        module_id: null,
        created_at: null,
        trainer_id: null,
      };

      this.getAssessmentTimeline();
    },

    applyFilters() {
      this.getAssessmentTimeline();
    },

    buildQueryParams() {
      const params = {};

      if (this.filters.module_id)
        params.module_id = this.filters.module_id;

      if (this.filters.trainer_id)
        params.trainer_id = this.filters.trainer_id;

      if (this.filters.created_at)
        params.from_date = this.filters.created_at;
      return params;
    },

    clearFilter() {
      if (this.dataTableInstance) {
        $.fn.dataTable.ext.search.pop();
        this.dataTableInstance.draw();
      }
    },
  },
  created() {
    this.getModules();
    this.getTrainers();
    this.getAssessmentTimeline();
    let intervalId;
    if (!this.employees.length) {
      intervalId = setInterval(() => {
        this.employees = this.$store.getters["odoo/getAllEmployees"] || [];
        if (this.employees.length) {
          clearInterval(intervalId);
        }
      }, 1000);
    }
  },

  beforeUnmount() {
    // Clean up DataTable instance when component is destroyed
    if (this.dataTableInstance) {
      this.dataTableInstance.destroy();
    }
  },
};
</script>

<style scoped>
.page-item.active .page-link {
  z-index: 3;
  color: #fff;
  background-color: #4a81d4;
  border-color: #4a81d4;
}

.action-icon {
  cursor: pointer;
  font-size: 18px;
  text-decoration: none;
}

.action-icon:hover {
  opacity: 0.8;
}

.badge {
  padding: 5px 10px;
  font-size: 12px;
  font-weight: 500;
  border-radius: 4px;
}

.badge-warning {
  background-color: #ffc107;
  color: #212529;
}

.badge-info {
  background-color: #17a2b8;
  color: white;
}

.badge-success {
  background-color: #28a745;
  color: white;
}

.badge-secondary {
  background-color: #6c757d;
  color: white;
}

.text-muted {
  color: #6c757d !important;
}

.spinner-border {
  width: 3rem;
  height: 3rem;
}
</style>